import { Validator } from '@vista-digital/validator';
import { defaultSeatPickerLegendItems, seatPickerLegendItemConfigValidator } from './legend-item';
import { SeatPickerLegendPosition, seatPickerLegendPositionValidator } from './legend-position';
export const defaultSeatPickerLegendConfig = {
    position: SeatPickerLegendPosition.Top,
    items: defaultSeatPickerLegendItems,
    seatSize: 25
};
export const seatPickerLegendConfigValidator = Validator.object({
    position: seatPickerLegendPositionValidator,
    items: Validator.array({ items: seatPickerLegendItemConfigValidator }),
    seatSize: Validator.number({ min: 0 })
});
